import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionEyebrow from "@/components/SectionEyebrow";
import { MISSIONS, IMAGES } from "@/data/content";

const Section = ({ title, eyebrow, items, dark }) => (
  <section className={`mv-section ${dark ? "bg-[#F8FAFC]" : "bg-white"}`}>
    <div className="mv-container">
      <div className="max-w-2xl mb-12">
        <SectionEyebrow>{eyebrow}</SectionEyebrow>
        <h2 className="mt-5 font-heading font-black text-4xl sm:text-5xl tracking-tight text-[#1C1C1C]">
          {title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((m, i) => (
          <article key={i} className="card-flat group" data-testid={`mission-card-${i}`}>
            <div className="aspect-[4/3] overflow-hidden">
              <img src={m.image} alt={m.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-6">
              <h3 className="font-heading font-bold text-xl text-[#1C1C1C]">{m.title}</h3>
              <p className="mt-2 text-sm text-muted leading-relaxed">{m.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const Missions = () => {
  return (
    <div data-testid="missions-page">
      <section className="relative min-h-[55vh] flex items-end overflow-hidden">
        <img src={IMAGES.heroOutreach} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/55 to-black/20" />
        <div className="relative mv-container py-24 text-white">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-white/80" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold">Nos missions</span>
          </div>
          <h1 className="font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] max-w-4xl">
            Sur le terrain.<br />Aux quatre coins du monde.
          </h1>
        </div>
      </section>

      <Section title="Au cœur d'Haïti." eyebrow="Missions locales" items={MISSIONS.local} />
      <Section title="Au-delà des frontières." eyebrow="Missions internationales" items={MISSIONS.international} dark />
      <Section title="Planter de nouvelles églises." eyebrow="Implantation d'églises" items={MISSIONS.churchPlants} />

      {/* PROJECTS EN COURS */}
      <section className="py-24 bg-[#0B3D91] text-white" data-testid="projects-section">
        <div className="mv-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-white/80" />
              <span className="text-xs uppercase tracking-[0.2em] font-bold">Projets en cours</span>
            </div>
            <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">
              Des projets concrets, soutenus par votre engagement.
            </h2>
            <p className="mt-5 text-lg text-blue-100 leading-relaxed max-w-2xl">
              De la construction de salles de prière aux campagnes d'évangélisation digitale,
              en passant par les programmes de soutien scolaire — chaque projet est une opportunité
              d'agir.
            </p>
          </div>
          <div className="lg:col-span-5 flex flex-col gap-3">
            <Link to="/donation" className="bg-white text-[#0B3D91] hover:bg-blue-50 inline-flex items-center justify-between gap-2 px-7 py-4 font-bold transition-all">
              Soutenir un projet <ArrowRight size={18} />
            </Link>
            <Link to="/join" className="border-2 border-white text-white hover:bg-white hover:text-[#0B3D91] inline-flex items-center justify-between gap-2 px-7 py-4 font-bold transition-all">
              Participer à une mission <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Missions;
